import React from "react";
import { useParams } from 'react-router-dom';
import CadastrarOrcamentos from "./CadastrarOrcamentos";

const EditarOrcamento = () => {
    const { id } = useParams();

    return <CadastrarOrcamentos orcamentoId={id} />;
};

export default EditarOrcamento;
